import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from '../libs/game-engine/src/EntryPoint';
import { initUi } from '../ui/initUi';

export default class InitState extends BaseState {
    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('game:gameStarted', this.onGameStarted, this);
    }

    onGameStarted() {
        this.complete();
    }

    onEnd() {
        super.onEnd();
        if (!EntryPoint.GameSettings.introScreen) {
            window.OPWrapperService.freeBetsController.show();
            initUi();
        }
    }
}
